import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent implements OnInit {

  @Input() title: string;
  @Input() description: string;
  @Input() type: string = 'info';
  @Input() image: string;
  @Input() badge: string;
  @Input() noFace: boolean = false;


  constructor() { }

  ngOnInit() {}

}
